import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import Axios from "../../../Axios";
import PopupConfirmSettings from "./PopupConfirmSettings";
import ModalTypeAction from "./ModalTypeAction.tsx";
import ModalLocation from "./ModalLocation.tsx";
import PopupConfirmLocation from "./PopupConfirmLocation";
import Table from "../../Table.tsx";
import { SettingTile } from "./SettingTile.tsx";
import { Slider, SliderRange } from "../../Slider.tsx";

import APIRequest from "../../../JS/APIRequest.ts";
import { Asset, AssetTable } from "../../Asset.tsx";


export class SettingItem {
    id_settings: string;
    name: string;
    value: number;
    default_value: number;

    constructor(id_settings: string, name: string, value: number, default_value: number) {
        this.id_settings = id_settings;
        this.name = name;
        this.value = value;
        this.default_value = default_value;
    }
}

class SettingsDB {
    weekend: SettingItem;
    calendarStartHour: SettingItem;
    calendarEndHour: SettingItem;
    timeCloseAction: SettingItem;
    timeDeleteImage: SettingItem;
    maxFileSize: SettingItem;
    calendarStep: SettingItem;

    constructor(settings: SettingItem[]) {
        settings.map(setting => {
            switch (setting?.name) {
                case "show weekend": this.weekend = setting; break;
                case "calendar start hour": this.calendarStartHour = setting; break;
                case "calendar end hour": this.calendarEndHour = setting; break;
                case "number minute close action": this.timeCloseAction = setting; break;
                case "number month delete image": this.timeDeleteImage = setting; break;
                case "max file size mo": this.maxFileSize = setting; break;
                case "calendar step": this.calendarStep = setting; break;
            }
        })
    }

    toArray(): SettingItem[] {
        return [
            this.weekend,
            this.calendarStartHour,
            this.calendarEndHour,
            this.timeCloseAction,
            this.timeDeleteImage,
            this.maxFileSize,
            this.calendarStep,
        ];
    }

    clone(): SettingsDB {
        return new SettingsDB([...this.toArray()]);
    }

}

export function SettingsPanel({ }) {
    const { t } = useTranslation();
    const [listTypeAction, setListTypeAction] = useState([]);
    const [listLocation, setListLocation] = useState([]);
    const [showPopupConfirm, setShowPopupConfirm] = useState(false);
    const [showPopupConfirmLocation, setShowPopupConfirmLocation] = useState(false);
    const [showPopupSettingsAction, setShowPopupSettingsAction] = useState(false);
    const [showPopupSettingsLocation, setShowPopupSettingsLocation] = useState(false);

    const [currentTypeAction, setCurrentTypeAction] = useState();
    const [currentLocation, setCurrentLocation] = useState();

    const [update, setUpdate] = useState('0');
    const [inPlanning, setInPlanning] = useState(false);

    const [settings, setSettings] = useState<SettingsDB>();


    const getAllSettings = async () => {
        const response = await Axios.get(`/api/setting/`, {
            headers: {
                "Content-Type": "application/json",
                "auth-token": sessionStorage.getItem('token')
            },
            withCredentials: true
        });

        if (response.status === 200) {
            const settingsItem: SettingItem[] = [];
            response.data.map((item: { id_settings: string; name: string; value: string; default_value: string; }) => {
                settingsItem.push(new SettingItem(item.id_settings, item.name, parseInt(item.value), parseInt(item.default_value)))
            });
            setSettings(new SettingsDB([...settingsItem]));
        }
    }

    const resetSetting = async (data, name_settings) => {
        try {
            const response = await Axios.put(`/api/setting/reset/?name=${name_settings}`, data, {
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": sessionStorage.getItem('token')
                },
                withCredentials: true
            });
            if (response.status === 200) {
                await getAllSettings();
            }
        }
        catch (error) {
            console.error("Error during reset " + name_settings + " : ", error);
        }
    }

    const updateSetting = async (event, setting: SettingItem | undefined) => {
        if (setting == null) return;

        if (event.target.value == '') {
            setting.value = event.target.checked ? 1 : 0;
        }
        else setting.value = parseInt(event.target.value);


        try {
            const response = await Axios.put(`/api/setting/?id=${setting.id_settings}`, setting, {
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": sessionStorage.getItem('token')
                },
                withCredentials: true
            });

            if (response.status === 200) {
                await getAllSettings();
            }
            else console.error(response)
        }
        catch (error) {
            console.error("Error during update number day show:", error);
        }
    }

    useEffect(() => {
        setCurrentLocation(undefined)
        setCurrentTypeAction(undefined)

        async function fetchData() {
            await getAllSettings();

            //TODO rename setters
            const responses = await APIRequest.fetchData({
                setLocations: setListLocation,
                setTypeAction: setListTypeAction
            });
        }

        fetchData();
        setUpdate(0);
    }, [update]);

    return (<div>
        <div className="grid w-full">
            <div className="flex flex-wrap w-full">
                <div className="max-[1150px]:w-full min-[1150px]:w-1/2">
                    <Table
                        raws={listLocation}
                        nbCols={2}
                        border='border border-y'
                        twStyle={`text-left font-medium text-gray-500`}
                        rawTemplate={(location, index) => {
                            return <>
                                <p className="pl-2 py-1 text-gray-900"> {location.name} </p>
                                <div className="flex items-center place-content-end mx-4 space-x-4">
                                    <button className="text-blue-500 hover:text-blue-600" onClick={() => {
                                        setCurrentLocation(location)
                                        setShowPopupSettingsLocation(true);
                                    }}>
                                        {t('modify')}
                                    </button>
                                    <button className="text-red-500 hover:text-red-700" onClick={() => {
                                        setCurrentLocation(location)
                                        setShowPopupConfirmLocation(true);
                                    }}>
                                        {t('delete')}
                                    </button>
                                </div>
                            </>
                        }}
                        colTemplate={(col, index) => {
                            return <div key={index} className="col-span-2">
                                <p className="text-xl text-center font-medium text-gray-500"> {t(col)} </p>
                            </div>
                        }}
                        firstRaw={
                            <button className="inline-flex bg-blue-100 justify-center font-medium text-slate-600 py-0.5 w-full hover:bg-blue-300" onClick={() => { setShowPopupSettingsLocation(true) }}  >
                                <svg fill="#334155" width={15} height={15} viewBox="0 0 45.5 45.5" className="mt-1.5">
                                    <path d="M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141 c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27 c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435 c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z"></path>
                                </svg>
                                <p className="ml-2"> {t('Location')} </p>
                            </button>
                        }
                    />
                </div>


                <div className="max-[1150px]:w-full min-[1150px]:w-1/2">
                    <Table
                        raws={listTypeAction}
                        nbCols={2}
                        border='border border-y'
                        twStyle={`text-xm text-left font-medium text-gray-500`}
                        rawTemplate={(typeAction, index) => {
                            return <>
                                <div className="inline-flex py-1">
                                    <img className="w-8 h-8 inline mx-4" src={`data:image/svg+xml;base64,${typeAction.icon}`} alt="" />
                                    <p className="pl-2 py-0.5 text-gray-900"> {typeAction.name} </p>
                                </div>
                                <div className="flex flex-row items-center place-content-end mx-4 space-x-4">
                                    <button className="text-blue-500 hover:text-blue-600" onClick={() => {
                                        setCurrentTypeAction(typeAction)
                                        setShowPopupSettingsAction(true);
                                    }}>
                                        {t('modify')}
                                    </button>
                                    <button className="text-red-500 hover:text-red-700" onClick={() => {
                                        setCurrentTypeAction(typeAction)
                                        isInPlanning(typeAction.id_type_action).then(r => {
                                            setShowPopupConfirm(true);
                                        });
                                    }}>
                                        {t('delete')}
                                    </button>
                                </div>
                            </>
                        }}
                        colTemplate={(col, index) => {
                            return <div key={index} className="col-span-2">
                                <p className="text-xl text-center font-medium text-gray-500"> {t(col)} </p>
                            </div>
                        }}
                        firstRaw={
                            <button className="inline-flex bg-blue-100 justify-center font-medium text-slate-600 py-0.5 w-full hover:bg-blue-300" onClick={() => { setShowPopupSettingsAction(true) }}  >
                                <svg fill="#334155" width={15} height={15} viewBox="0 0 45.5 45.5" className="mt-1.5">
                                    <path d="M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141 c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27 c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435 c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z"></path>
                                </svg>
                                <p className="ml-2"> {t('Mission type')} </p>
                            </button>
                        }
                    />
                </div>
            </div>
        </div>

        <div className="mx-[10%] space-y-3">

            <SettingTile
                name={t('show week-end')}
                form={
                    <div className="w-full place-self-end h-full py-3 p-2 grid items-center">
                        <label className="flex items-center cursor-pointer place-self-center">
                            <input type="checkbox" value="" checked={settings?.weekend.value === 1} className="sr-only peer" onChange={e => updateSetting(e, settings?.weekend)} /> {/* e.target.checked */}
                            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer bg-gray-500 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-blue-600"></div>
                        </label>
                    </div>
                }
            />

            <SettingTile
                icon={false}
                name={t('nb month delte image')}
                form={
                    <div className="w-full place-self-end p-2">
                        <Slider
                            min={0}
                            max={5}
                            ticks={[...Array(6)].map((_, i) => ((i + 1) * 6))}
                            value={settings?.timeDeleteImage.value}
                            onChange={e => updateSetting(e, settings?.timeDeleteImage)}
                        />
                    </div>
                }
            />

            <SettingTile
                icon={false}
                name={t('nb minute close action')}
                form={
                    <div className="w-full place-self-end p-2">
                        <Slider
                            min={0}
                            max={5}
                            ticks={[...Array(6)].map((_, i) => ((i + 1) * 20))}
                            value={settings?.timeCloseAction.value}
                            onChange={e => updateSetting(e, settings?.timeCloseAction)}
                        />
                    </div>

                }
            />


            <SettingTile
                icon={false}
                name={t('Plage horaire de l\'affichage du calendrier')}
                form={
                    <div className="w-full place-self-end py-3 p-2">
                        <SliderRange
                            min={0}
                            max={24}
                            valueStart={settings?.calendarStartHour.value}
                            valueEnd={settings?.calendarEndHour.value}
                            onChangeStart={e => updateSetting(e, settings?.calendarStartHour)}
                            onChangeEnd={e => updateSetting(e, settings?.calendarEndHour)}
                            step={1}
                            visualStep={6}
                        />
                    </div>
                }
            />

            <SettingTile
                icon={false}
                name={t('calendar step')}
                form={
                    <div className="w-full place-self-end p-2">
                        <Slider
                            min={0}
                            max={5}
                            ticks={[5, 10, 15, 20, 30, 60]}
                            value={settings?.calendarStep.value}
                            onChange={e => updateSetting(e, settings?.calendarStep)}
                        />
                    </div>

                }
            />

        </div>

        <PopupConfirmSettings
            show={showPopupConfirm}
            setShowPopupConfirm={setShowPopupConfirm}
            idAction={currentTypeAction?.id_type_action}
            setUpdate={setUpdate}
            name={currentTypeAction?.name}
            inPlanning={inPlanning}
        />

        <ModalTypeAction
            isOpen={showPopupSettingsAction}
            toggle={setShowPopupSettingsAction}
            data={currentTypeAction}
            onClose={setUpdate}
        />

        <ModalLocation
            isOpen={showPopupSettingsLocation}
            toggle={setShowPopupSettingsLocation}
            data={currentLocation}
            onClose={setUpdate}
        />

        <PopupConfirmLocation
            show={showPopupConfirmLocation}
            setShowPopupConfirm={setShowPopupConfirmLocation}
            idLocation={currentLocation?.id_location}
            setUpdate={setUpdate}
            name={currentLocation?.name}
        />
    </div>
    );

}
